import {SET_IS_EDIT, SET_SELECT_IMAGE, SET_SHOW_FORM, SET_TITLE} from "./constants";

const initialState = {
    showForm: false,
    selectedImage: null,
    title: "",
    isEdit: false
}
export const BoardCreateReducer = (state = initialState, action) => {
    switch (action.type){
        case SET_SHOW_FORM:
            return {
                ...state,
                showForm: action.payload
            }
        case SET_SELECT_IMAGE:
            return {
                ...state,
                selectedImage: action.payload
            }
        case SET_TITLE:
            return {
                ...state,
                title: action.payload
            }
        case SET_IS_EDIT:
            return {
                ...state,
                isEdit: action.payload
            }
        default:
            return state
    }
}